<script setup>
import { Actions, EventManager } from "@events";
import VideoCallButton from "../Common/VideoCallButton.vue";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const actionEmitter = EventManager.getActionEmitter(props.rtcId);

function hangupClick() {
  actionEmitter.emit(Actions.HangUp, { hangupBy: "local" });
}
</script>
<template>
  <VideoCallButton
    style="background-color: #dd2c00; border-color: #dd2c00"
    icon="mdi-phone-cancel"
    @click="hangupClick"
  ></VideoCallButton>
</template>
